export const moduleNames = {

  // ADMIN MODULES
  ADMIN_HOME: 'adminHome',
  ADMIN_REPORT_DROPDOWN: 'adminReportDropdownd',
  ADMIN_REPORT_BALANCE: 'adminReportBalance',
  ADMIN_REPORT_OFFERS: 'adminReportOffers',
  ADMIN_REPORT_ADVERTISERS: 'adminReportAdvertisers',
  ADMIN_REPORT_COUNTRIES: 'adminReportCountries',
  ADMIN_REPORT_USERS: 'adminReportUsers',
  ADMIN_REPORT_DYNAMICS: 'adminReportDynamics',
  ADMIN_REPORT_ORDERS: 'adminReportOrders',
  ADMIN_USERS_DROPDOWN: 'adminUsersDropdown',
  ADMIN_USERS: 'adminUsers',
  ADMIN_USERS_UNAPPROVED: 'adminUsersUnapproved',
  ADMIN_NEWS: 'adminNews',
  ADMIN_DOMAINS: 'adminDomains',
  ADMIN_OFFERS_DROPDOWN: 'adminOffersDropdown',
  ADMIN_OFFERS_SUBSCRIPTIONS: 'adminOffersSubscriptions',
  ADMIN_OFFERS_SUBSCRIPTIONS_PAYMENTS: 'adminOffersSubscriptionsPayments',
  ADMIN_OFFERS: 'adminOffers',
  ADMIN_OFFERS_SINGLE: 'adminOffersSingle',
  ADMIN_OFFERS_ACCESS: 'adminOffersAccess',
  ADMIN_OFFERS_BLACKLIST_USERS: 'adminOffersBlacklistUsers',
  ADMIN_OFFERS_PAYOUT_OFFERS: 'adminOffersPayoutOffers',
  ADMIN_OFFERS_PAYOUT_USERS: 'adminOffersPayoutUsers',
  ADMIN_OFFERS_USERS_GUARANTEES: 'adminOffersUsersGuarantees',
  ADMIN_GUARANTEES_DROPDOWN: 'adminGuaranteesDropdown',
  ADMIN_GUARANTEES_LOGS: 'adminGuaranteesLogs',
  ADMIN_OFFERS_TRACKING_LINKS: 'adminOffersTrackingLinks',
  ADMIN_PAGES_DROPDOWN: 'adminPagesDropdown',
  ADMIN_LANDINGS: 'adminLandings',
  ADMIN_PRELANDINGS: 'adminPrelandings',
  ADMIN_LOGIN_HISTORY: 'adminLoginHistory',
  ADMIN_BALANCE: 'adminBalance',
  ADMIN_LOGS_DROPDOWN: 'adminLogsDropdown',
  ADMIN_LOGS_QUEUE_EMAIL: 'adminLogsQueueEmail',
  ADMIN_PAYMENTS: 'adminPayments',
  ADMIN_ORDERS_DROPDOWN: 'adminOrdersDropdown',
  ADMIN_ORDERS: 'adminOrders',
  ADMIN_ORDERS_ERRORS: 'adminOrdersErrors',
  ADMIN_TOPUPS: 'adminTopups',
  ADMIN_POSTBACK_LOGS: 'adminPostBackLogs',
  ADMIN_PROFILE: 'adminProfile',
  ADMIN_DASHBOARD: 'adminDashboard',
  ADMIN_CHANGELOG: 'adminChangelog',
  ADMIN_FAQ: 'adminFAQ',

  //AFFILIATE MODULES
  AFFILIATE_DASHBOARD: 'affiliateDashboard',
  AFFILIATE_DOMAINS: 'affiliateDomains',
  AFFILIATE_OFFERS_DROPDOWN: 'affiliateOffersDropdown',
  AFFILIATE_OFFERS_SUBSCRIPTIONS: 'affiliateOffersSubscriptions',
  AFFILIATE_OFFERS_SUBSCRIPTIONS_PAYMENTS: 'affiliateOffersSubscriptionsPayments',
  AFFILIATE_OFFERS_ALL: 'affiliateOffersAll',
  AFFILIATE_OFFERS_HOT: 'affiliateOffersHot',
  AFFILIATE_OFFERS_SINGLE: 'affiliateOffersSingle',
  AFFILIATE_OFFERS: 'affiliateOffers',
  AFFILIATE_LOGIN_HISTORY: 'affiliateLoginHistory',
  AFFILIATE_PROFILE: 'affiliateProfile',
  AFFILIATE_PAYMENTS: 'affiliatePayments',
  AFFILIATE_PAYMENTS_REQUEST: 'affiliatePaymentsRequest',
  AFFILIATE_PAYMENTS_SETTINGS: 'affiliatePaymentsSettings',
  AFFILIATE_BALANCE: 'affiliateBalance',
  AFFILIATE_REFERRAL: 'affiliateReferral',
  AFFILIATE_REFERRAL_STATS: 'affiliateReferralStats',
  AFFILIATE_REPORT: 'affiliateReport',
  AFFILIATE_ORDERS_DROPDOWN: 'affiliateOrdersDropdown',
  AFFILIATE_ORDERS: 'affiliateOrders',
  AFFILIATE_POSTBACK_DROPDOWN: 'affiliatePostbackDropdown',
  AFFILIATE_POSTBACK: 'affiliatePostback',
  AFFILIATE_POSTBACK_LOGS: 'affiliatePostbackLogs',
  AFFILIATE_FAQ: 'affiliateFAQ',

  //ADVERTISER MODULES
  ADVERTISER_DASHBOARD: 'advertiserDashboard',
  ADVERTISER_OFFERS: 'advertiserOffers',
  ADVERTISER_ORDERS: 'advertiserOrders',
  ADVERTISER_TOPUPS: 'advertiserTopups',
  ADVERTISER_PAGES_DROPDOWN: 'advertiserPagesDropdown',
  ADVERTISER_LANDINGS: 'advertiserLandings',
  ADVERTISER_PRELANDINGS: 'advertiserPrelandings',
  ADVERTISER_LOGIN_HISTORY: 'advertiserLoginHistory',
  ADVERTISER_PROFILE: 'advertiserProfile',
  ADVERTISER_FAQ: 'advertiserFAQ',

  //SYSTEM MODULES
  LOGOUT: 'logout',
  ADMIN_FAST_LOGIN: 'Log in as',

  //DEV MODULES
  DEV_BUILDER_DROPDOWN: 'devBuilderDropdown',
  DEV_BUILDER_MODULE: 'devModuleBuilder',
}